export const STEERING_PAGES = {
  DASHBOARD: "Dashboard",
  PROJECT_TIMELINE: "ProjectsTimeline",
  PROJECT_MANAGER_KPI: "ProjectManagerKpi",
};

export const SPS_CATEGORIES = {
  CATEGORY_1: "CATEGORY_1",
  CATEGORY_2: "CATEGORY_2",
  CATEGORY_3: "CATEGORY_3",
};
